import React from "react";
import { Box, Button } from "designsystem";
import { Spacing } from "designsystem/utils/theme";
import { replaceLocaleAddTrailingSlash } from "utils/locales";
import useLayout from "hooks/use-layout";
import pushToDataLayer from "utils/gtm";

interface CardButtonProps {
  links: GatsbyTypes.Maybe<
    readonly GatsbyTypes.Maybe<GatsbyTypes.LinkNodeFragment | null>[]
  >;
  marginTop?: Spacing | undefined;
}
const CardButtons: React.FC<CardButtonProps> = ({ links, marginTop }) => {
  const { locale } = useLayout();
  return links?.length ? (
    <Box marginTop={marginTop}>
      {links.map((link, index) =>
        link && link.url && link.text ? (
          <Button
            onClick={() => {
              if (link && link.url && link.text) {
                pushToDataLayer("cta_click", "", {
                  cta: {
                    text: link.text,
                    class: 'className + " " + style',
                    target_url: link.url.includes("_LOCALE_")
                      ? replaceLocaleAddTrailingSlash(link.url, locale)
                      : link.url,
                    id: "card-button"
                  }
                });
              }
            }}
            as="a"
            id="card-button"
            href={
              link.url.includes("_LOCALE_")
                ? replaceLocaleAddTrailingSlash(link.url, locale)
                : link.url
            }
            buttonType={
              links.length === 1 || index > 0 ? "secondary" : "primary"
            }
            marginLeft={index > 0 ? "xs" : undefined}
            size="s"
            key={`card-button-${link.text}`}
          >
            {link.text}
          </Button>
        ) : undefined
      )}
    </Box>
  ) : null;
};

export default CardButtons;
